import { ApiService } from '@services/api';
import { API_DOMAIN } from '@constants/api';
import {
  ICreateCredentialProps,
  IGetCredentialProps,
  IUpdateCredentialProps,
  IGenerateURLProps,
} from '@domain/interfaces/dashboard/IntegrationCenter/InfoProduct/Platforms/IPerfectPayAuth';

export class PerfectPayService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public getCredential({ storeAliasId }: IGetCredentialProps): Promise<any> {
    return this.apiService.get(`/api/v1/users/stores/${storeAliasId}/perfect-pay-credentials`);
  }

  public createCredential({ storeAliasId, data }: ICreateCredentialProps): Promise<any> {
    return this.apiService.post(`/api/v1/users/stores/${storeAliasId}/perfect-pay-credentials`, {
      ...data,
    });
  }

  public updateCredential({
    storeAliasId,
    credentialAliasId,
    data,
  }: IUpdateCredentialProps): Promise<any> {
    return this.apiService.put(
      `/api/v1/users/stores/${storeAliasId}/perfect-pay-credentials/${credentialAliasId}`,
      {
        ...data,
      },
    );
  }

  public generateWebhookURL({ storeAliasId }: IGenerateURLProps): Promise<any> {
    return this.apiService.post(
      `/api/v1/users/stores/${storeAliasId}/perfect-pay-credentials/generate-webhook-url`,
    );
  }
}

const perfectPayService = new PerfectPayService(API_DOMAIN);

export default perfectPayService;
